import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { taxInformationModalConfirmedTaxInformationSelector } from '../../selectors';
import { secondaryTaxIdSelector, taxIdSelector } from '../../stages/paid_stage/billing_information_card/selectors';
import { defaultInitialValues, setInitialValues, setPopupLocation, setShouldUpdateExistingSubscription, setShowThankYouPopup, setVisibility } from '../tax_information_modal/slice';
const styledBareButtonCss = "svl6ctn";
const StyledBareButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledBareButtonCss, props.className)} />);
const taxInformationButtonWrapperCss = "t2hopr6";
const TaxInformationButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(taxInformationButtonWrapperCss, props.className)} />;
});
export const AddOrEditTaxInformationButton = ({
  location,
  countryCode,
  postalCode
}) => {
  const taxId = useSelector(taxIdSelector);
  const secondaryTaxId = useSelector(secondaryTaxIdSelector);
  const dispatch = useDispatch();
  const track = useTrack();
  const confirmedTaxInformation = useSelector(taxInformationModalConfirmedTaxInformationSelector);
  const initialFormValues = {
    ...defaultInitialValues,
    countryCode: countryCode || 'AF',
    postalCode: postalCode || '',
    ...(confirmedTaxInformation || {})
  };
  const segmentModalName = action => {
    switch (location) {
      case 'plan_upgrade_quick_checkout_flow':
        return 'plan_upgrade';
      case 'add_seats_quick_checkout_flow':
        return 'add_seats';
      case 'add_on_quick_checkout_flow':
        return 'add_on_purchase';
      case 'deal_link_checkout_flow':
        return 'deal_page_tax_info_modal';
      default:
        return action === 'edit_tax_info_modal_open' && 'edit_tax_info' || action === 'add_tax_info_modal_open' && 'add_tax_info' || null;
    }
  };
  return <TaxInformationButtonWrapper>
      <StyledBareButton as="a" onClick={() => {
      const action = taxId || secondaryTaxId || confirmedTaxInformation ? 'edit_tax_info_modal_open' : 'add_tax_info_modal_open';
      track({
        name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
        properties: {
          action,
          location,
          modal_name: segmentModalName(action)
        }
      });
      dispatch(setVisibility(true));
      dispatch(setPopupLocation(location));
      dispatch(setShowThankYouPopup(false));
      if (location === 'deal_link_checkout_flow') {
        dispatch(setShouldUpdateExistingSubscription(false));
        dispatch(setInitialValues(initialFormValues));
      }
    }}>
        {taxId || secondaryTaxId || confirmedTaxInformation ? I18n.t('publisher.billing.checkout.summary.edit_tax_information') : I18n.t('publisher.billing.checkout.summary.add_tax_information')}
      </StyledBareButton>
    </TaxInformationButtonWrapper>;
};

require("./add_or_edit_tax_information_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_or_edit_tax_information_button.js");